import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('dtemis') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemis.i"
            control={control}
            label="Data de Emissão Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtemis') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemis.f"
            control={control}
            label="Data de Emissão Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtlanc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtlanc.i"
            control={control}
            label="Data de Lançamento Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtlanc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtlanc.f"
            control={control}
            label="Data de Lançamento Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('conta_id') && (
        <Grid item xs={12}>
          <Dropdown
            name="conta_id"
            control={control}
            label="Conta"
            options={drops?.Cxconta?.filter((f) => f?.visualizar === 'SIM')}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('valor') && (
        <Grid item xs={12}>
          <InputMask name="valor" control={control} label="Valor" />
        </Grid>
      )}
      {checkDisplay('conciliado') && (
        <Grid item xs={12}>
          <Dropdown
            name="conciliado"
            control={control}
            label="Conciliado"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('detalhes') && (
        <Grid item xs={12}>
          <Input name="detalhes" control={control} label="Detalhes" />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
